import { ReEvent } from "../interfaces/types";

// Function to get the event date or period as a string
export function getEventDateOrPeriod(event: ReEvent): string {
  // Convert startDate and endDate from the event to Date objects
  const startDate = event.startDate ? new Date(event.startDate) : null;
  const endDate = event.endDate ? new Date(event.endDate) : null;

  // Check if the startDate and endDate are on the same day
  if (startDate?.getDate() === endDate?.getDate()) {
    // If they are on the same day, return the startDate as a localized date string
    return startDate?.toLocaleDateString() || "";
  } else {
    // If they are on different days, return the period as a string in the format "startDate - endDate"
    return `${startDate?.toLocaleDateString()} - ${endDate?.toLocaleDateString()}`;
  }
}

export function currentTimeIsBetweenDates(
  // Function to check if the current time is between two given dates
  startDate: Date,
  endDate: Date
): boolean {
  const currentDate = new Date();
  // Return true if the current date is between startDate and endDate, inclusive
  return startDate <= currentDate && currentDate <= endDate;
}
